<template>
  <div id="app">
    <v-app>
      <v-toolbar fixed class="text-xs-center" dark>
        <img src="../static/logozw.png" id="decovLogo" >
      </v-toolbar>
      <v-content>
        <router-view/>
      </v-content>
      <template>
        <v-footer>
          <v-container style="margin:auto">
            <v-layout column style="margin:auto">
              <v-layout row>
                <v-spacer></v-spacer>
                <div>Made by:
                  <a class="dark--text" href="https://weblighting.be" target="_blank">Weblighting</a>
                </div>
              </v-layout>
            </v-layout>
          </v-container>
        </v-footer>
      </template>
    </v-app>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
export default {
  name: 'app',
  mounted () {
    this.actFillProducts()
    this.actFillStaticText()
  },
  methods: {
    ...mapActions([
      'actFillProducts',
      'actFillStaticText'
    ])
  },
  computed: {
    ...mapGetters({
      categories: 'getCatagories',
      staticText: 'getStaticText'
    })
  }
}
</script>

<style lang="scss">
  @import "../node_modules/vuetify/dist/vuetify.min.css";
  @import "./main.scss";

</style>



// WEBPACK FOOTER //
// src/App.vue